import { Formik } from 'formik';
import { isEmpty } from 'lodash';
import { object, string } from 'yup';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { postMemoir, destroyMemoir, patchMemoir, postPrivateEventDetails } from '../../api';
import { prepareAttrs } from '../../../utils/api';
import { useHistory, useMatch } from '../../../app/hooks';
import { useCurrentMember } from '../../../members/hooks';
import { useEntity, useEntityActionCreators } from '../../../entities/hooks';
import FullPageForm from '../../../app/full-page-form';
import RelationshipForm from './form';

const MemoirRelationship = () => {
  const { params } = useMatch();
  const { pathname } = useLocation();
  const isPublicRoute = pathname.includes('/get-started')
  const { push } = useHistory();
  const { entity: memoir } = useEntity({ ...params });
  const { receive, receiveDeletion } = useEntityActionCreators();
  const { 'first-name': firstName, id: memberId } = useCurrentMember();
  const initialValues = {
    'subject-relation-noac': (memoir && memoir['subject-relation']) || '',
  };
  const validationSchema = object().shape({
    'subject-relation-noac': string().required(),
  });
  const isInitialValid = validationSchema.isValidSync(initialValues);

  const backPath = '/';

  useEffect(() => {
    if (isPublicRoute && memberId)
      postPrivateEventDetails('memoir_pre_creation', {
        'subject-type': 'Member',
        'subject-id': memberId,
      });
  }, [isPublicRoute, memberId])

  return (
    <FullPageForm
      onExitClick={() => {
        if (memoir && memoir.id) {
          destroyMemoir(memoir.id)
            .then(() => receiveDeletion({ entityType: 'memoirs', id: memoir.id }))
            .then(() => push(backPath));
        } else {
          push(backPath);
        }
      }}
      title="Create a Memoir"
      mt={isPublicRoute && '70px'}
    >
      <Formik
        {...{ initialValues, isInitialValid, validationSchema }}
        onSubmit={async values => {
          let memoirId = undefined
          const currentUserIsSubject = values['subject-relation-noac'] === 'me';
          const getNextPath = id =>
            currentUserIsSubject
              ? `/memoirs/${isPublicRoute ? 'get-started' : 'new'}/${id}/memoir-name`
              : `/memoirs/${isPublicRoute ? 'get-started' : 'new'}/${id}/subject-name`;

          if (isEmpty(memoir)) {
            // POST memoir
            const attributes = prepareAttrs(values);
            if (currentUserIsSubject) {
              attributes['subject-name'] = firstName;
            }
            attributes['subject-alive'] = true;
            const body = {
              data: {
                attributes,
              },
            };
            const memoirRes = await postMemoir(body);
            const [id] = memoirRes.data.result.memoirs;
            receive({ payload: memoirRes });
            memoirId = id
            push(getNextPath(id));
          } else {
            // PATCH memoir
            const patchBody = prepareAttrs({ ...values, 'lock-version': memoir['lock-version'] });
            const memoirRes = await patchMemoir({ id: memoir.id, ...patchBody });
            const [id] = memoirRes.data.result.memoirs;
            receive({ payload: memoirRes });
            memoirId = id
            push(getNextPath(id));
          }
          if (isPublicRoute) {
            postPrivateEventDetails('memoir_who_is_it_about_clicked_next', {
              'subject-type': 'Memoir',
              'subject-id': memoirId,
            });
          }
        }}
        render={props => <RelationshipForm {...props} />}
      />
    </FullPageForm>
  );
};

export default MemoirRelationship;
